import styled from '@emotion/styled/macro'
import React from 'react'

export default function Skeleton() {
  return (
    <Wrapper>
      <div className='half flex-column gap-1'></div>
      <div className='img' />
    </Wrapper>
  )
}

const Wrapper = styled('article')(() => ({
  width: '100%',
  height: '150px',
  borderRadius: 'var(--radius)',
  position: 'relative',
  overflow: 'hidden',
  padding: '1rem',
  transition: '.5s all',
  cursor: 'pointer',
  background: 'var(--black-player-500)!important',
  // animation: ' pulse 2s linear infinite',
  '.half': {
    cursor: 'pointer',
    paddingRight: '.5rem',
    maxWidth: '50%',
    h2: {
      color: 'var(--text-50)',
      fontFamily: 'var(--primary-bold)',
      fontSize: '1rem',
    },
    h3: { color: 'var(--text-50)', fontSize: '.8em' },
    h4: { color: 'var(--text-50)', fontSize: '.7rem' },
  },

  '.img': {
    borderRadius: 'var(--radius)',
    position: 'absolute',
    width: '125px',
    height: '150px',
    bottom: '0',
    left: '100%',
    transform: 'translate(-85%,5%) rotate(25deg)',
    boxShadow: '0px 0px 10px black',
    transition: '.5s all',
    background: 'var(--black-player-500)!important',
  },

  ':hover': {
    img: {
      transform: 'translate(-100%,0%) rotate(0deg)',
      height: '100%',
      width: '150px',
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
    },
  },
  // '@keyframes pulse': {
  //   '0% , to ': {
  //     background: ' red!important',
  //   },
  //   '50%': {
  //     background: 'blue!important',
  //   },
  // },
}))
